export default __webpack_public_path__ + "static/media/logo.cb0835ee.svg";